// extracted by mini-css-extract-plugin
export var orderDetails = "_u6-2";
export var orderImage = "_u6-1";
export var orderMeta = "_u6-3";
export var orderSummary = "_u6-0";
export var rightArrow = "_u6-4";